export const IMPORT_REQUEST_STATUS = {
  AWAITING_MAPPING: 'AWAITING_MAPPING',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
} as const;

export type ImportRequestStatusType =
  (typeof IMPORT_REQUEST_STATUS)[keyof typeof IMPORT_REQUEST_STATUS];

export type EventStateImportRequestItem = {
  id: string;
  filePath: string;
  importStatus: ImportRequestStatusType;
  importedAt: string | null;
  createdAt: string;
  errorReport: string | null;
};

export type EventStateImportHistoryResponse = {
  data: EventStateImportRequestItem[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
};
